// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--xks60","message":"a10a3f92e9--message--YNFXS","icon":"a10a3f92e9--icon--1zmNL"};